import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

@Injectable({
  providedIn: 'root',
})
export class UserApiService extends ApiHttpService {
  #organisation = 'auth/api/users'

  constructor() {
    const baseUrl = inject<string>('BASE_URL' as any)
    const httpClient = inject(HttpClient)

    super(baseUrl, httpClient)
  }

  validateOnLogin(): Observable<{ id: string; designerUser: boolean }> {
    return this.post(`${this.#organisation}/validate-on-login`, null)
  }
}
